module.exports = __webpack_public_path__ + "img/what.d5d3c3f0.svg";